import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  Pagination,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { ChevronRight } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { formatDistanceToNow } from "date-fns";
import GeneralLoading from "../../../shared-components/Loading";

const SyncListItem = ({ sync }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        p: 1,
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      {/* Status + Timestamp */}
      <Stack direction="row" spacing={2} alignItems="center">
        {sync.inProgress ? (
          <GeneralLoading message={"Syncing..."} direction={"row"} size={30} />
        ) : (
          <>
            <Chip
              label={sync.syncStatus || "Unknown"}
              color={sync.completed ? "success" : "error"}
              size="small"
            />

            <Typography variant="body2" color="text.secondary">
              {sync.lastUpdated
                ? `Updated ${formatDistanceToNow(new Date(sync.lastUpdated), {
                    addSuffix: true,
                  })}`
                : "No timestamp"}
            </Typography>
          </>
        )}
      </Stack>

      {/* View Button */}
      <Button
        variant="outlined"
        endIcon={<ChevronRight />}
        onClick={() => navigate(`sync/${sync.id}`)}
      >
        View
      </Button>
    </Box>
  );
};

export const SchoolSyncsAccordion = ({ syncs, disabled = false }) => {
  const [expanded, setExpanded] = useState(false);
  const theme = useTheme();
  const PAGE_SIZE = 5;
  const [page, setPage] = useState(1);

  const totalPages = Math.ceil(syncs.length / PAGE_SIZE);

  const displayedSyncs = syncs.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const handlePageChange = (_event, value) => {
    setPage(value);
  };
  return (
    <Box sx={{ mt: 2 }}>
      <Accordion expanded={expanded} variant={"outlined"} disabled={disabled}>
        <AccordionSummary onClick={() => setExpanded(!expanded)}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
          >
            <Typography
              variant="subtitle2"
              fontWeight="medium"
              sx={{ ml: 1, color: theme.palette.primary.main }}
            >
              Wonde Syncs
            </Typography>
          </Stack>
          <ExpandMore />
        </AccordionSummary>
        <AccordionDetails>
          {displayedSyncs.map((sync, index) => (
            <SyncListItem key={index} sync={sync} />
          ))}
        </AccordionDetails>
        {totalPages > 1 && (
          <Stack alignItems="center" mt={2}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={handlePageChange}
              color="primary"
            />
          </Stack>
        )}
      </Accordion>
    </Box>
  );
};
